<template>
  <donut-chart-card
    :size="size"
    title="종사자 현황"
    :value="data"
    unit="명"
    :init-total="total"
    :isMoveWrite="isMoveWrite"
    :orientation="orientation"
    @detail="onClickDetail"
    @write="onClickWrite"
  ></donut-chart-card>
</template>

<script>
import DonutChartCard from '@/components/DonutChartCard'

export default {
  name: 'DonutChart02',
  components: {DonutChartCard},
  props: {
    dataType: 'detail' | 'field' | 'address' | 'company' | 'project',
    size: String,
    reloadCount: Number,
    orientation: {
      type: "landscape" | "portrait",
      default: () => "portrait"
    },
  },
  computed: {
    projectId () {
      return this.$route.params.proj_id
    },
    isMoveWrite () {
      // if (Number(`${this.projectId}`) === 1) return false
      // else return true
      return true
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  watch: {
    dataType (/*value*/) {
      this.loadGraph()
    },
    reloadCount () {
      this.loadGraph()
    }
  },
  data () {
    return {
      graphId: 2,
      boardIds: [299, 358],
      data: [{label: '데이터 없음', value: 0}],
      total : -1,
    }
  },
  async mounted () {
    await this.loadGraph()
  },
  methods: {
    async loadGraph () {
      let projectIds = [];
      if (this.projectId) {
        projectIds = [this.projectId];
      } else {
        projectIds = undefined;
      }

      const donutData = await this.$store.dispatch('summary/LOAD_DONUT_02', {
        projectIds,
        depth: projectIds ? 1 : 0,
        fromYear: new Date().getFullYear() + 1,
      });

      let tmpData = {};
      const parsedData = [];
      switch (this.dataType) {
      case 'project':
        tmpData = donutData.project;
        break;
      case 'company':
        tmpData = donutData.company;
        break;
      case 'field':
        tmpData = donutData.field;
        break;
      case 'detail':
        if (this.getLevel === 4) {
          tmpData = donutData.employee_type;
        } else {
          tmpData = donutData.company;
        }
        break;
      }

      if (Object.keys(tmpData).length > 0) {
        for (const key of Object.keys(tmpData)) {
          if (tmpData[key].yearly.total > 0) {
            parsedData.push({
              label: tmpData[key].label,
              value: tmpData[key].yearly.total,
            });
          }
        }
        this.data = parsedData;
      }

      // 합계는, 전체 분야 데이터에서 가져온다
      let projectTotal = 0;
      for (const projectItem of donutData.project) {
        projectTotal += projectItem.yearly.total;
      }
      this.total = projectTotal;
    },

    convertListData (list) {
      // 데이터 변형하기,
      // 매달 마지막에 작성 글을 기준으로 변경하기,
      const temp = {}
      for (const data of list) {
        const date = new Date(data.created_at).format('yyyy-MM-01')
        if (data.post_content) {
          temp[date] = JSON.parse(data.post_content)
        }
      }
      return temp;
    },
    onClickDetail () {
      const projectId = this.$route.params.proj_id
      const graphId = this.graphId
      if (projectId) {
        this.$router.push(`/project/${projectId}/graph-detail/${graphId}`)
      } else {
        this.$router.push(`/graph-detail/${graphId}`)
      }
    },
    onClickWrite () {
      const proj_id = this.$route.params.proj_id
      const boardId = `${this.boardId}`
      this.$router.push({name: 'write|tab', params: {proj_id, boardId}})
    }
  },
}
</script>

<style scoped>

</style>
